import React from 'react';

export default function PlusIcon({className}) {
	return (
        <svg className={className ? className : ''} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 11.1" preserveAspectRatio="xMidYMid meet"><path d="M1.1 4.4c.2 0 .4-.1.5-.2l1.6-1.6v4.6c0 .4.3.8.8.8s.8-.3.8-.8V2.6l1.6 1.6c.3.3.8.3 1.1 0 .3-.3.3-.8 0-1.1L4.5.2c-.3-.3-.8-.3-1.1 0L.5 3.1c-.3.3-.3.8 0 1.1.2.1.4.2.6.2zM7.2 9.6H.8c-.5 0-.8.3-.8.7s.3.8.8.8h6.5c.4 0 .8-.3.8-.8s-.5-.7-.9-.7z"/></svg>
	);
}
